export const FAQ_ITEMS = [
  {
    q: "What is Xevon?",
    a: "Xevon is a next-generation Discord bot that combines powerful moderation, advanced automation, security, tickets, leveling, voice tools, and more — all in one fast, reliable bot.",
  },
  {
    q: "How do I add Xevon?",
    a: "Click any \"Add Xevon\" button on this website. You'll be taken to Discord's official authorization page where you can pick your server and approve the requested permissions.",
  },
  {
    q: "What permissions are required?",
    a: "Xevon's invite requests Administrator permission so every module — moderation, security, tickets, leveling, and voice — works out of the box. Individual commands enforce their own Discord permissions (such as Ban Members or Manage Channels), which are listed on the Commands page.",
  },
  {
    q: "Is Xevon free?",
    a: "Yes. Xevon's core features are free to use. An optional Premium tier with additional benefits is planned — see the Premium page for the latest details.",
  },
  {
    q: "What is Premium?",
    a: "Premium is an optional upgrade that unlocks extra benefits and enhanced limits for your server. Premium tiers and pricing are announced through the support server and the Premium page when available.",
  },
  {
    q: "How do I get support?",
    a: "Join the official Xevon support server — the link is on the Support page. The team and community can help with setup, configuration, and troubleshooting.",
  },
  {
    q: "How do I delete server data?",
    a: "Visit the Server Data Deletion page for full details on what Xevon stores and how to request deletion. Requests are handled through the support server.",
  },
  {
    q: "How do I report a problem?",
    a: "Report bugs or abuse in the support server. You can also check the Status page first to see whether there is a known service disruption.",
  },
];
